import {
	createCleanup,
	createReaction,
	getResult,
	PromiseStatus,
	untrack,
} from "fluidstate";
import { LocationData } from "../location/location-data";
import { VNode } from "preact";
import { PageName, pages } from "../../pages";
import { LocationActions } from "../location/location-actions";
import { setAppContent } from "../../components/app";

const TIME_BETWEEN_LOADING_START_AND_DISPLAY_MS = 400;

export type PageData = {
	details: {
		[K in PageName]?: Promise<VNode>;
	};

	selectedPageName: PageName;

	isSelectedPageLoadingShown: boolean;
};

export const createPageData = (locationData: LocationData): PageData => {
	return {
		details: {},

		get selectedPageName() {
			const trimmedPathname = locationData.pathname
				.replace(/^\//, "")
				.replace(/.html$/, "");

			if (trimmedPathname === "") {
				return "index";
			}

			if (trimmedPathname in pages) {
				return trimmedPathname as PageName;
			}

			return "not_found";
		},

		isSelectedPageLoadingShown: false,
	};
};

export const createPageActions = (locationActions: LocationActions) => {
	return {
		openPage(pageName: PageName) {
			locationActions.push(`${pageName}.html`);
		},
	};
};

export const createPageReactions = (pageData: PageData) => {
	return [
		createReaction(() => {
			const selectedPageName = pageData.selectedPageName;
			untrack(() => {
				if (!pageData.details[selectedPageName]) {
					pageData.details[selectedPageName] =
						pages[selectedPageName].component();
				}
			});
		}),

		createReaction(() => {
			const promise = pageData.details[pageData.selectedPageName];
			if (promise) {
				const promiseResult = getResult(promise);
				if (promiseResult.status === PromiseStatus.Success) {
					setAppContent(promiseResult.result);
				}
			}
		}),

		createReaction(() => {
			const promise = pageData.details[pageData.selectedPageName];
			if (promise) {
				const promiseResult = getResult(promise);
				if (promiseResult.status === PromiseStatus.Success) {
					document.title = pages[pageData.selectedPageName].title;
				}
			}
		}),

		createReaction(() => {
			const selectedPageDetails = pageData.details[pageData.selectedPageName];

			if (
				!selectedPageDetails ||
				getResult(selectedPageDetails).status === PromiseStatus.Loading
			) {
				const setDisplayPageLoadingTimeout = setTimeout(() => {
					pageData.isSelectedPageLoadingShown = true;
				}, TIME_BETWEEN_LOADING_START_AND_DISPLAY_MS);

				createCleanup(() => {
					clearTimeout(setDisplayPageLoadingTimeout);
				});
			} else {
				pageData.isSelectedPageLoadingShown = false;
			}
		}),
	];
};
